import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { SharedService } from '../../services/shared-service/shared.service';
import { ResetPassErrorConstants } from '../../constants/error-messages';
import { ResetPassLabelConstants } from '../../constants/label-constants';

@Component({
  selector: 'app-reset-pass-page',
  templateUrl: './reset-pass-page.component.html',
  styleUrls: ['./reset-pass-page.component.scss'],
})

export class ResetPassPageComponent implements OnInit {

  resetPasswordForm: FormGroup | any;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  submitted: boolean = false;
  encryptedUserId: any;
  errorConstants: any;
  labelConstants: any;
  isLinkValid: boolean = false;
  currentYear: number = new Date().getFullYear();;

  currentUrlTime: any;
  passwordPattern: RegExp
  showRequirements: boolean = false;
  isLoading: boolean = false;
  requirements = {
    lowercase: false,
    uppercase: false,
    number: false,
    specialChar: false,
    length: false,
  };

  constructor(
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly spinner: NgxSpinnerService,
    private readonly toastr: ToastrService,
    private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly sharedService: SharedService
  ) {
    this.passwordPattern = /^(?=.*[A-Za-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&\-_^()+={}|\\/<>,.;:'~`])[A-Za-z\d@$!%*#?&\-_^()+={}|\\/<>,.;:'~`]{8,}$/;
    this.resetPasswordForm = this.fb.group(
      {
        NewPassword: [
          '',
          [Validators.required, Validators.pattern(this.passwordPattern)],
        ],
        ConfirmNewPassword: ['', [Validators.required]],
      },
      {
        validator: this.passwordMatchValidator,
      }
    );
  }

  ngOnInit(): void {
    localStorage.clear();
    this.sharedService.setData("Reset Password");
    this.encryptedUserId = this.route.snapshot.paramMap.get('Id');
    this.currentUrlTime = this.route.snapshot.paramMap.get('time');
    this.errorConstants = ResetPassErrorConstants;
    this.labelConstants = ResetPassLabelConstants;
    this.isResetPassValid();
  }

  get changePassControls() {
    return this.resetPasswordForm.controls;
  }

  togglePasswordVisibility(fieldName: string) {
    (this as any)[fieldName] = !(this as any)[fieldName];
  }

  togglePasswordRequirements(show: boolean) {
    this.showRequirements = show;
  }

  passwordMatchValidator(formGroup: FormGroup): { [key: string]: boolean } | null {
    const newPassword = formGroup.get('NewPassword')?.value;
    const confirmPassword = formGroup.get('ConfirmNewPassword')?.value;
    return newPassword && confirmPassword && newPassword !== confirmPassword ? { mismatch: true } : null;
  }

  checkPasswordValidity() {
    const newPassword = this.changePassControls['NewPassword'].value || '';
    this.requirements.lowercase = /[a-z]/.test(newPassword);
    this.requirements.uppercase = /[A-Z]/.test(newPassword);
    this.requirements.number = /[0-9]/.test(newPassword);
    this.requirements.specialChar = /[!@#\$%^&*]/.test(newPassword);
    this.requirements.length = newPassword.length >= 8;
  }

  submitResetPassForm() {
    this.submitted = true;
    if (this.resetPasswordForm.valid) {
      this.setLoadingState(true);
      this.submitted = false;
      this.spinner.show();
      let api = this.api.apiUrl.ForgotPassword.ResetPassword;
      let passwordChangeRequestModel = {
        UserId: Number.parseInt(this.commonService.DecryptForId(this.encryptedUserId)),
        NewPassword: this.resetPasswordForm.value.NewPassword?.trim(),
        ConfirmPassword: this.resetPasswordForm.value.ConfirmNewPassword?.trim()
      };
      this.commonService.doPut(api, passwordChangeRequestModel).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            this.setLoadingState(false);
            this.toastr.success(response.message);
            this.spinner.hide();
            this.router.navigate(['/login']);
          } else {
            this.setLoadingState(false);
            this.toastr.error(response.message);
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.setLoadingState(false);
          this.spinner.hide();
        }
      });
    }
  }

  isResetPassValid() {
    this.spinner.show();
    let api = this.api.apiUrl.ForgotPassword.ValidateResetPassword;
    let passwordChangeRequestModel = {
      UserId: this.encryptedUserId,
      EncryptedURLDateTime: this.currentUrlTime
    }
    this.commonService.doPost(api, passwordChangeRequestModel).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
        }
        else {
          this.isLinkValid = true;
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
      }
    });
  }

  setLoadingState(isLoading: boolean) {
    this.isLoading = isLoading;
    if (isLoading) {
      this.resetPasswordForm.disable();
    } else {
      this.resetPasswordForm.enable();
    }
  }
}
